export default function NotFound(props) {
  return (
    <div>
      <h2>404</h2>
      <p>Nie znaleziono takiej strony.</p>
    </div>
  );
}